import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

export const columns = (handleUpdate, handleDelete) => [
  {
    field: "name",
    headerName: "Döküman Adı",
    sortable: false,
    filterable: false,
    flex: 1,
  },
  {
    field: "actions",
    headerName: "İşlemler",
    flex: 1,
    sortable: false,
    filterable: false,
    disableExport: true,
    renderCell: (params) => (
      <div style={{ display: "flex", gap: 8, marginTop: 5 }}>
        <IconButton
          variant="contained"
          color="secondary"
          onClick={() => handleUpdate(params.row)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          variant="contained"
          color="error"
          onClick={() => handleDelete(params.row)}
        >
          <DeleteIcon />
        </IconButton>
      </div>
    ),
  },
];
